<svg id="Next" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
    <circle id="Ellipse_20" data-name="Ellipse 20" cx="25" cy="25" r="25" fill="rgba(0,132,200,0.1)"/>
    <g id="round-arrow_forward-24px" transform="translate(17.418 17)">
        <path id="Path_14" data-name="Path 14" d="M1,6.593H12.17L7.29,1.712a1.008,1.008,0,0,1,0-1.42,1,1,0,0,1,1.41,0l6.59,6.59a1,1,0,0,1,0,1.41l-6.58,6.6a1,1,0,0,1-1.41-1.41l4.87-4.89H1a1,1,0,0,1,0-2Z" fill="#0084c8"/>
    </g>
</svg>
